import React from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT, SUCCESS, MALE } from 'app/config/constants';
import { colors } from 'app/config/color';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';

export interface IFederatedInfoDetailProps extends StateProps, DispatchProps {
  modalShow: boolean;
  handleClose: Function;
}

export interface IFederatedInfoDetailState {
  showUpdate: boolean;
  attributes: any;
}

export class FederatedInfoDetail extends React.Component<IFederatedInfoDetailProps, IFederatedInfoDetailState> {
  state: IFederatedInfoDetailState = {
    showUpdate: false,
    attributes: []
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.userProfile !== nextProps.userProfile) {
      const { userProfile } = nextProps;

      if (userProfile && userProfile.attributes) {
        userProfile.attributes.map(item => {
          item.isChecked = false;
        });
        this.setState({
          attributes: userProfile.attributes
        });
      }
    }
  }

  handleAllChecked = event => {
    let attributes = this.state.attributes;
    attributes.forEach(element => (element.isChecked = event.target.checked));
    this.setState({ attributes: attributes });
  };

  handleCheckChieldElement = event => {
    let attributes = this.state.attributes;
    attributes.forEach(element => {
      if (element.value === event.target.value) element.isChecked = event.target.checked;
    });
    this.setState({ attributes: attributes });
  };

  update = () => {
    if (this.state.showUpdate) {
      //update thanh cong thay isChecked = false
    }

    this.setState(prevState => ({
      showUpdate: !prevState.showUpdate
    }));
  };

  renderRow = (label, value, attributesLoa, claim, colorRow?) => {
    return (
      <Row className="justify-content-md-center pt-2" style={{ backgroundColor: colorRow }}>
        <Col md={2}>
          {this.state.showUpdate ? <input type="checkbox" /> : null}
          <label>{label}</label>
        </Col>
        <Col md={8}>
          <label className="font-weight-bold">{value && value.indexOf('null') === -1 ? value : '----------'}</label>
        </Col>
        <Col md={2} className="text-center">
          <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />
        </Col>
      </Row>
    );
  };
  render() {
    const { attributes } = this.state;
    return (
      <div>
        <Modal
          className="modal-lg hide-border-bottom-modal"
          isOpen={this.props.modalShow}
          toggle={this.props.handleClose}
          backdrop="static"
          centered={window.location === window.parent.location}
          style={{ maxWidth: '90%' }}
        >
          <ModalHeader toggle={this.props.handleClose}>
            <h4 className="font-weight-bold">Thông tin bảo hiểm xã hội</h4>
            {this.state.showUpdate ? <p style={{ fontSize: 'large' }}>Chọn thông tin bạn muốn cập nhật vào thông tin định danh</p> : null}
          </ModalHeader>
          <ModalBody className="pt-0">
            <div>
              <Row>
                <Col md={2}>
                  {this.state.showUpdate ? <input type="checkbox" onClick={this.handleAllChecked} value="checkedall" /> : null}
                  {this.state.showUpdate ? <label>Chọn tất cả</label> : null}
                </Col>
              </Row>
              {attributes
                ? attributes.map((item, index) => (
                    <Row key={index} style={{ backgroundColor: index % 2 === 0 ? colors.backgroundColorRow : '', paddingTop: '7px' }}>
                      <Col md={2}>
                        {this.state.showUpdate ? (
                          <input type="checkbox" onClick={this.handleCheckChieldElement} checked={item.isChecked} value={item.value} />
                        ) : null}
                        <label>{item.label}</label>
                      </Col>
                      <Col md={8}>
                        {item.name === 'gender' && item.value ? (
                          <label className="font-weight-bold">{item.value === MALE ? 'Nam' : 'Nữ'}</label>
                        ) : (
                          <label className="font-weight-bold">{item.value ? item.value : ''}</label>
                        )}
                      </Col>
                      <Col md={2} className="text-center">
                        <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />
                      </Col>
                    </Row>
                  ))
                : null}
            </div>
            <div className="row justify-content-md-center mt-4">
              <div className="col col-md-4">
                <button className="btn btn-outline-primary col-md-12" type="button">
                  <span className="spanBtn">BỎ QUA</span>
                </button>
              </div>
              <div className="col col-md-4">
                <Button className="btn-register" type="button" onClick={() => this.update()} block>
                  <span className="spanBtn">CẬP NHẬT VÀO THÔNG TIN ĐỊNH DANH</span>
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  userProfile: storeState.userInfo.userProfile
});

const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FederatedInfoDetail);
